module.exports = __webpack_public_path__ + "img/galeria-agua-dulce2.569941b1.jpg";